import Vue from 'vue';

export const state = () => ({
    data: {
        totalamount: 0,
        sysamount: 0,
        questionamount: 0,
    },
});

export const mutations = {
    updateData(state, n) {
        state.data = n;
    },
};

export const getters = {
    getData(state) {
        return state.data;
    },
    // 合计新消息数
    getTotal(state, getters) {
        return getters.getData.totalamount;
    },
};

export const actions = {
    /**
     * 请求用户身份信息，仅在有SERIAL_CODE时请求
     * @param {Object} state state实例
     * @param {Object} obj 参数
     * @returns 
     */
     queryMsgNum(state) {
        const SERIAL_CODE = this.$cookies.get('SERIAL_CODE');

        if (!SERIAL_CODE) return;

        Vue.prototype.$get(`${this.state.api.webUrl}/message/getmessagenumber.json`, data => {
            state.commit('updateData', data);
        });
    },
};